var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thumbs-up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M17.016 38.712h3.203c.432 0 .792-.144 1.116-.36a3.73 3.73 0 0 0 2.52.972H34.04c2.484 0 4.104-1.368 4.392-3.636l1.367-8.602v-.288a3.78 3.78 0 0 0-3.779-3.78h-4.68v-3.24c0-1.727-.503-2.987-1.547-3.743-1.584-1.152-3.636-.576-3.887-.504-.433.144-.72.54-.72 1.008v4.176c0 2.807-3.204 3.851-3.6 3.995a1.987 1.987 0 0 0-1.404-.576H16.98c-1.08 0-1.98.9-1.98 1.98v10.582c.036 1.116.936 2.016 2.016 2.016Zm5.183-11.95c.576-.18 5.111-1.692 5.111-6.011v-3.276c.432-.036.936.036 1.296.288.468.324.684 1.008.684 2.016v4.32c0 .575.468 1.043 1.044 1.043h5.723a1.688 1.688 0 0 1 1.692 1.692v.036L36.38 35.4v.037c-.072.504-.216 1.8-2.304 1.8H23.891a1.689 1.689 0 0 1-1.692-1.693v-8.782Zm-5.075-.504h2.951v10.366h-2.951V26.258Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thumbs-up_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgThumbsUp;